import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Button,
  useTheme,
} from '@mui/material';
import { AutoStories } from '@mui/icons-material';

const AboutMe = () => {
  const theme = useTheme();

  const sideProjects = [
    {
      title: 'The Adventures of Virtue: Aristotle\'s Guide to Being Your Best Self',
      description: 'A children\'s book that introduces young readers to the timeless wisdom of Aristotle, teaching them about virtues in a fun and accessible way.',
      imageUrl: '/images/book_adventures_of_virtue.jpg', // Placeholder - User needs to add this image
      link: 'https://www.amazon.com/Adventures-Virtue-Aristotles-Guide-Being/dp/B0DFLYCPXV/',
    },
    {
      title: 'Never Judge a Monster by its Cover',
      description: 'A heartwarming story that teaches children about empathy, acceptance, and looking beyond appearances. A tale of an unlikely friendship.',
      imageUrl: '/images/book_never_judge_monster.jpg', // Placeholder - User needs to add this image
      link: 'https://www.amazon.com/Never-Judge-Monster-Douglas-Hineline/dp/B0DFTLBCM3/',
    },
  ];

  return (
    <Box
      id="about"
      sx={{
        width: '100vw',
        position: 'relative',
        left: '50%',
        right: '50%',
        marginLeft: '-50vw',
        marginRight: '-50vw',
        py: 8,
        background: `linear-gradient(180deg, ${theme.palette.background.default} 0%, ${theme.palette.background.paper} 100%)`,
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center', mb: 6 }}>
          <Typography
            variant="h2"
            sx={{
              mb: 2,
              fontWeight: 700,
              background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}
          >
            About Me
          </Typography>
          <Typography
            variant="h5"
            color="text.secondary"
            sx={{ maxWidth: 800, mx: 'auto', mb: 4 }}
          >
            I am the very proud father of 2 great kids (an incorrigible dog and a flock of bothersome chickens), a lifelong martial artist, hobby gardener and former bee keeper.
          </Typography>
          <Typography variant="h6" color="text.primary">
            I'm also a published childrens' author! Check these out:
          </Typography>
        </Box>

        <Grid container spacing={4} justifyContent="center">
          {sideProjects.map((project, index) => (
            <Grid item xs={12} sm={6} md={5} key={index}>
              <Card
                sx={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  background: 'rgba(255, 255, 255, 0.9)',
                  backdropFilter: 'blur(10px)',
                  border: '1px solid rgba(255, 255, 255, 0.2)',
                  transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: '0 8px 40px rgba(0,0,0,0.15)',
                  },
                }}
              >
                <CardMedia
                  component="img"
                  height="250"
                  image={project.imageUrl}
                  alt={project.title}
                  sx={{ borderBottom: `1px solid ${theme.palette.divider}` }}
                />
                <CardContent sx={{ flexGrow: 1, p:3 }}>
                  <Typography gutterBottom variant="h5" component="div" fontWeight={600}>
                    {project.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {project.description}
                  </Typography>
                </CardContent>
                <Box sx={{ p: 2, pt: 0, paddingBottom: '16px !important' }}>
                  <Button
                    variant="contained"
                    startIcon={<AutoStories />}
                    href={project.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    fullWidth
                  >
                    View on Amazon
                  </Button>
                </Box>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default AboutMe; 